import React, { Fragment } from "react";
import { Icon, notification, Row, Col, Tag, Tooltip } from "antd";
import AppConfig from "../../config/AppConfig";
import { getOrderTypeLabel } from "../../helpers/orders";
import I18n from '../../common/I18n';
const PickupIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <g clipPath="url(#clip0_13415_89499)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#FF2D78"
      />
      <path
        d="M19.5031 19.9582C20.6282 19.9582 21.4501 19.6869 21.9688 19.1443C22.4954 18.6017 22.7587 17.8596 22.7587 16.918C22.7587 16.4871 22.6909 16.0961 22.5553 15.745C22.4276 15.3859 22.2281 15.0827 21.9568 14.8354C21.6935 14.58 21.3583 14.3845 20.9514 14.2489C20.5444 14.1132 20.0617 14.0454 19.5031 14.0454H17.229V19.9582H19.5031ZM19.5031 11.3164C20.6921 11.3164 21.7174 11.456 22.5792 11.7353C23.449 12.0146 24.1631 12.4056 24.7217 12.9083C25.2803 13.403 25.6912 13.9935 25.9545 14.6798C26.2258 15.366 26.3615 16.1121 26.3615 16.918C26.3615 17.7718 26.2218 18.5538 25.9426 19.264C25.6633 19.9742 25.2404 20.5846 24.6738 21.0953C24.1073 21.606 23.3931 22.0049 22.5313 22.2922C21.6695 22.5715 20.6601 22.7111 19.5031 22.7111H17.229V28.6838H13.6382V11.3164H19.5031Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13415_89499">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const DeliveryIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <g clipPath="url(#clip0_13415_89500)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#15C989"
      />
      <path
        d="M27.7858 19.9941C27.7858 21.2628 27.5704 22.4318 27.1395 23.5011C26.7166 24.5624 26.1141 25.476 25.3322 26.242C24.5581 27.0081 23.6245 27.6065 22.5314 28.0374C21.4382 28.4683 20.2253 28.6838 18.8927 28.6838H12.2139V11.3164H18.8927C20.2253 11.3164 21.4382 11.5319 22.5314 11.9627C23.6245 12.3936 24.5581 12.9961 25.3322 13.7701C26.1141 14.5361 26.7166 15.4498 27.1395 16.5111C27.5704 17.5723 27.7858 18.7333 27.7858 19.9941ZM24.0993 19.9941C24.0993 19.0844 23.9796 18.2665 23.7402 17.5404C23.5009 16.8143 23.1577 16.1999 22.7109 15.6971C22.264 15.1944 21.7174 14.8074 21.0711 14.5361C20.4327 14.2648 19.7066 14.1292 18.8927 14.1292H15.8286V25.871H18.8927C19.7066 25.871 20.4327 25.7393 21.0711 25.476C21.7174 25.2047 22.264 24.8177 22.7109 24.315C23.1577 23.8043 23.5009 23.1859 23.7402 22.4598C23.9796 21.7336 24.0993 20.9117 24.0993 19.9941Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13415_89500">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const PickDeliveryIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <g clipPath="url(#clip0_13415_89501)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#617AD6"
      />
      <path
        d="M10.5749 19.9582C11.7 19.9582 12.5219 19.6869 13.0406 19.1443C13.5672 18.6017 13.8305 17.8596 13.8305 16.918C13.8305 16.4871 13.7627 16.0961 13.627 15.745C13.4994 15.3859 13.2999 15.0827 13.0286 14.8354C12.7653 14.58 12.4301 14.3845 12.0232 14.2489C11.6162 14.1132 11.1335 14.0454 10.5749 14.0454H8.30073V19.9582H10.5749ZM10.5749 11.3164C11.7638 11.3164 12.7892 11.456 13.651 11.7353C14.5207 12.0146 15.2349 12.4056 15.7935 12.9083C16.352 13.403 16.763 13.9935 17.0263 14.6798C17.2976 15.366 17.4333 16.1121 17.4333 16.918C17.4333 17.7718 17.2936 18.5538 17.0143 19.264C16.7351 19.9742 16.3121 20.5846 15.7456 21.0953C15.1791 21.606 14.4649 22.0049 13.6031 22.2922C12.7413 22.5715 11.7319 22.7111 10.5749 22.7111H8.30073V28.6838H4.70996V11.3164H10.5749Z"
        fill="white"
      />
      <path
        d="M35.2902 19.9941C35.2902 21.2628 35.0748 22.4318 34.6439 23.5011C34.221 24.5624 33.6185 25.476 32.8365 26.242C32.0625 27.0081 31.1289 27.6065 30.0357 28.0374C28.9426 28.4683 27.7297 28.6838 26.3971 28.6838H19.7183V11.3164H26.3971C27.7297 11.3164 28.9426 11.5319 30.0357 11.9627C31.1289 12.3936 32.0625 12.9961 32.8365 13.7701C33.6185 14.5361 34.221 15.4498 34.6439 16.5111C35.0748 17.5723 35.2902 18.7333 35.2902 19.9941ZM31.6037 19.9941C31.6037 19.0844 31.484 18.2665 31.2446 17.5404C31.0053 16.8143 30.6621 16.1999 30.2153 15.6971C29.7684 15.1944 29.2218 14.8074 28.5755 14.5361C27.9371 14.2648 27.211 14.1292 26.3971 14.1292H23.333V25.871H26.3971C27.211 25.871 27.9371 25.7393 28.5755 25.476C29.2218 25.2047 29.7684 24.8177 30.2153 24.315C30.6621 23.8043 31.0053 23.1859 31.2446 22.4598C31.484 21.7336 31.6037 20.9117 31.6037 19.9941Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13415_89501">
        <rect height="40" width="40" />
      </clipPath>
    </defs>
  </svg>
);

const BeyondIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <g clipPath="url(#clip0_13415_89501)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#5B6EF5"
      />
      <text
        x="20"
        y="28"
        fill="white"
        fontSize="24"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontWeight="bold"
        textAnchor="middle"
      >
        B
      </text>
    </g>
    <defs>
      <clipPath id="clip0_13415_89501">
        <rect height="40" width="40" />
      </clipPath>
    </defs>
  </svg>
);

const ExclusiveIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <g clipPath="url(#clip0_13415_89501)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#F59E0B"
      />
      <text
        x="20"
        y="28"
        fill="white"
        fontSize="24"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontWeight="bold"
        textAnchor="middle"
      >
        E
      </text>
    </g>
    <defs>
      <clipPath id="clip0_13415_89501">
        <rect height="40" width="40" />
      </clipPath>
    </defs>
  </svg>
);

const HotshotIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <g clipPath="url(#clip0_13415_89501)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#EF4444"
      />
      <text
        x="20"
        y="28"
        fill="white"
        fontSize="24"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontWeight="bold"
        textAnchor="middle"
      >
        H
      </text>
    </g>
    <defs>
      <clipPath id="clip0_13415_89501">
        <rect height="40" width="40" />
      </clipPath>
    </defs>
  </svg>
);



const AirportToAirportIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <g clipPath="url(#clip0_13415_89501)">
      {/* Background Rounded Square */}
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#617AD6"
      />

      {/* First Letter 'A' */}
      <path
        d="M11.11 11.32H14.54L19.54 28.68H15.93L14.86 24.63H10.74L9.68 28.68H6.11L11.11 11.32ZM13.98 21.32L12.82 16.89L11.64 21.32H13.98Z"
        fill="white"
      />

      {/* Second Letter 'A' */}
      <path
        d="M25.46 11.32H28.89L33.89 28.68H30.28L29.21 24.63H25.09L24.03 28.68H20.46L25.46 11.32ZM28.33 21.32L27.17 16.89L25.99 21.32H28.33Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13415_89501">
        <rect height="40" width="40" />
      </clipPath>
    </defs>
  </svg>
);



const RecoveryDeliveryIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <g clip-path="url(#clip0_13415_89502)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#2BACFB"
      />
      <path
        d="M9.87544 19.5393C10.4579 19.5393 10.9607 19.4675 11.3836 19.3238C11.8065 19.1722 12.1536 18.9687 12.4249 18.7134C12.6962 18.4501 12.8957 18.1429 13.0233 17.7918C13.151 17.4407 13.2149 17.0577 13.2149 16.6427C13.2149 15.8208 12.9396 15.1825 12.389 14.7276C11.8464 14.2728 11.0165 14.0454 9.89938 14.0454H8.03218V19.5393H9.87544ZM18.2898 28.6838H15.0462C14.4397 28.6838 14.0008 28.4524 13.7295 27.9896L10.426 22.6632C10.2904 22.4558 10.1388 22.3042 9.97119 22.2084C9.8116 22.1127 9.57222 22.0648 9.25304 22.0648H8.03218V28.6838H4.44141V11.3164H9.89938C11.1123 11.3164 12.1496 11.4441 13.0114 11.6994C13.8732 11.9468 14.5794 12.2939 15.1299 12.7407C15.6805 13.1876 16.0835 13.7222 16.3388 14.3446C16.5942 14.959 16.7218 15.6373 16.7218 16.3794C16.7218 16.9539 16.6381 17.5005 16.4705 18.0192C16.3109 18.5299 16.0755 18.9967 15.7643 19.4196C15.4531 19.8425 15.0701 20.2175 14.6153 20.5447C14.1604 20.8718 13.6418 21.1352 13.0593 21.3347C13.2907 21.4623 13.5061 21.6179 13.7056 21.8015C13.9051 21.977 14.0846 22.1885 14.2442 22.4358L18.2898 28.6838Z"
        fill="white"
      />
      <path
        d="M35.5594 19.9941C35.5594 21.2628 35.3439 22.4318 34.913 23.5011C34.4901 24.5624 33.8877 25.476 33.1057 26.242C32.3317 27.0081 31.3981 27.6065 30.3049 28.0374C29.2117 28.4683 27.9988 28.6838 26.6662 28.6838H19.9874V11.3164H26.6662C27.9988 11.3164 29.2117 11.5319 30.3049 11.9627C31.3981 12.3936 32.3317 12.9961 33.1057 13.7701C33.8877 14.5361 34.4901 15.4498 34.913 16.5111C35.3439 17.5723 35.5594 18.7333 35.5594 19.9941ZM31.8728 19.9941C31.8728 19.0844 31.7532 18.2665 31.5138 17.5404C31.2744 16.8143 30.9313 16.1999 30.4844 15.6971C30.0376 15.1944 29.491 14.8074 28.8446 14.5361C28.2063 14.2648 27.4801 14.1292 26.6662 14.1292H23.6021V25.871H26.6662C27.4801 25.871 28.2063 25.7393 28.8446 25.476C29.491 25.2047 30.0376 24.8177 30.4844 24.315C30.9313 23.8043 31.2744 23.1859 31.5138 22.4598C31.7532 21.7336 31.8728 20.9117 31.8728 19.9941Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13415_89502">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const RecoveryTransferIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_13415_89503)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#D62BF9"
      />
      <path
        d="M11.7133 19.5393C12.2958 19.5393 12.7985 19.4675 13.2215 19.3238C13.6444 19.1722 13.9915 18.9687 14.2628 18.7134C14.5341 18.4501 14.7336 18.1429 14.8612 17.7918C14.9889 17.4407 15.0527 17.0577 15.0527 16.6427C15.0527 15.8208 14.7775 15.1825 14.2269 14.7276C13.6843 14.2728 12.8544 14.0454 11.7373 14.0454H9.87007V19.5393H11.7133ZM20.1277 28.6838H16.884C16.2776 28.6838 15.8387 28.4524 15.5674 27.9896L12.2639 22.6632C12.1283 22.4558 11.9767 22.3042 11.8091 22.2084C11.6495 22.1127 11.4101 22.0648 11.0909 22.0648H9.87007V28.6838H6.2793V11.3164H11.7373C12.9502 11.3164 13.9875 11.4441 14.8493 11.6994C15.7111 11.9468 16.4172 12.2939 16.9678 12.7407C17.5184 13.1876 17.9214 13.7222 18.1767 14.3446C18.4321 14.959 18.5597 15.6373 18.5597 16.3794C18.5597 16.9539 18.476 17.5005 18.3084 18.0192C18.1488 18.5299 17.9134 18.9967 17.6022 19.4196C17.291 19.8425 16.908 20.2175 16.4532 20.5447C15.9983 20.8718 15.4797 21.1352 14.8971 21.3347C15.1286 21.4623 15.344 21.6179 15.5435 21.8015C15.743 21.977 15.9225 22.1885 16.0821 22.4358L20.1277 28.6838Z"
        fill="white"
      />
      <path
        d="M33.7203 14.213H28.6453V28.6838H25.0426V14.213H19.9676V11.3164H33.7203V14.213Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13415_89503">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const OutboundTransferIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_13415_89504)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#FE8C36"
      />
      <path
        d="M28.8988 19.9942C28.8988 21.2629 28.6834 22.4399 28.2525 23.5251C27.8296 24.6103 27.2271 25.5479 26.4451 26.3379C25.6711 27.1279 24.7375 27.7503 23.6443 28.2051C22.5512 28.652 21.3383 28.8754 20.0057 28.8754C18.6731 28.8754 17.4602 28.652 16.3671 28.2051C15.2739 27.7503 14.3363 27.1279 13.5543 26.3379C12.7723 25.5479 12.1658 24.6103 11.735 23.5251C11.312 22.4399 11.1006 21.2629 11.1006 19.9942C11.1006 18.7255 11.312 17.5525 11.735 16.4752C12.1658 15.39 12.7723 14.4524 13.5543 13.6625C14.3363 12.8725 15.2739 12.2541 16.3671 11.8072C17.4602 11.3524 18.6731 11.125 20.0057 11.125C21.3383 11.125 22.5512 11.3524 23.6443 11.8072C24.7375 12.2541 25.6711 12.8765 26.4451 13.6744C27.2271 14.4644 27.8296 15.402 28.2525 16.4872C28.6834 17.5645 28.8988 18.7334 28.8988 19.9942ZM25.2243 19.9942C25.2243 19.0845 25.1046 18.2706 24.8652 17.5525C24.6258 16.8263 24.2787 16.2119 23.8239 15.7092C23.377 15.1985 22.8304 14.8115 22.1841 14.5482C21.5457 14.2769 20.8196 14.1412 20.0057 14.1412C19.1918 14.1412 18.4617 14.2769 17.8153 14.5482C17.169 14.8115 16.6184 15.1985 16.1636 15.7092C15.7167 16.2119 15.3736 16.8263 15.1342 17.5525C14.8948 18.2706 14.7751 19.0845 14.7751 19.9942C14.7751 20.9118 14.8948 21.7337 15.1342 22.4599C15.3736 23.178 15.7167 23.7885 16.1636 24.2912C16.6184 24.7939 17.169 25.1809 17.8153 25.4522C18.4617 25.7155 19.1918 25.8472 20.0057 25.8472C20.8196 25.8472 21.5457 25.7155 22.1841 25.4522C22.8304 25.1809 23.377 24.7939 23.8239 24.2912C24.2787 23.7885 24.6258 23.178 24.8652 22.4599C25.1046 21.7337 25.2243 20.9118 25.2243 19.9942Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13415_89504">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const CrossDockIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_13415_89505)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#AABDCD"
      />
      <path
        d="M25.446 24.4109C25.6455 24.4109 25.8131 24.4827 25.9487 24.6263L27.3731 26.1464C26.6709 27.0401 25.7971 27.7184 24.7518 28.1812C23.7145 28.644 22.4776 28.8754 21.0413 28.8754C19.7407 28.8754 18.5717 28.6559 17.5343 28.2171C16.497 27.7702 15.6153 27.1518 14.8891 26.3618C14.163 25.5719 13.6044 24.6343 13.2134 23.5491C12.8225 22.4639 12.627 21.2789 12.627 19.9942C12.627 19.1324 12.7187 18.3145 12.9022 17.5405C13.0938 16.7585 13.369 16.0404 13.7281 15.386C14.0872 14.7317 14.5181 14.1412 15.0208 13.6146C15.5315 13.088 16.106 12.6411 16.7444 12.274C17.3827 11.899 18.0769 11.6157 18.827 11.4242C19.5851 11.2247 20.391 11.125 21.2448 11.125C21.8832 11.125 22.4856 11.1809 23.0522 11.2926C23.6267 11.4043 24.1613 11.5599 24.656 11.7594C25.1508 11.9589 25.6056 12.2022 26.0205 12.4895C26.4434 12.7688 26.8225 13.076 27.1576 13.4111L25.9487 15.0629C25.8769 15.1666 25.7851 15.2584 25.6734 15.3382C25.5617 15.418 25.4101 15.4579 25.2186 15.4579C25.0271 15.4579 24.8316 15.39 24.6321 15.2544C24.4406 15.1187 24.2012 14.9671 23.9139 14.7996C23.6347 14.632 23.2796 14.4804 22.8487 14.3447C22.4258 14.2091 21.8872 14.1412 21.2328 14.1412C20.5067 14.1412 19.8404 14.2729 19.234 14.5362C18.6275 14.7996 18.1049 15.1826 17.666 15.6853C17.2351 16.18 16.9 16.7904 16.6606 17.5166C16.4212 18.2427 16.3015 19.0686 16.3015 19.9942C16.3015 20.9278 16.4292 21.7617 16.6845 22.4958C16.9478 23.2219 17.3029 23.8363 17.7498 24.339C18.2046 24.8417 18.7313 25.2248 19.3297 25.4881C19.9362 25.7434 20.5825 25.8711 21.2687 25.8711C21.6757 25.8711 22.0428 25.8512 22.3699 25.8113C22.7051 25.7714 23.0123 25.7035 23.2915 25.6078C23.5788 25.512 23.8461 25.3883 24.0935 25.2367C24.3488 25.0851 24.6042 24.8936 24.8595 24.6622C24.9473 24.5904 25.0391 24.5305 25.1348 24.4827C25.2306 24.4348 25.3343 24.4109 25.446 24.4109Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13415_89505">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const WarehouseOrderIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_13415_89505)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#54A2E0"
      />
      <path
        d="M 8 11 L 12 11 L 15 23 L 18 11 L 22 11 L 25 23 L 28 11 L 32 11 L 27 29 L 23 29 L 20 17 L 17 29 L 13 29 Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13415_89505">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const PickupCrossDockIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_13415_89506)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#EB548A"
      />
      <path
        d="M13.8957 19.8684C15.0208 19.8684 15.8427 19.597 16.3614 19.0544C16.888 18.5118 17.1513 17.7697 17.1513 16.8282C17.1513 16.3973 17.0835 16.0063 16.9478 15.6552C16.8202 15.2961 16.6207 14.9929 16.3494 14.7455C16.0861 14.4902 15.7509 14.2947 15.344 14.159C14.937 14.0234 14.4543 13.9555 13.8957 13.9555H11.6215V19.8684H13.8957ZM13.8957 11.2266C15.0846 11.2266 16.11 11.3662 16.9718 11.6455C17.8415 11.9248 18.5557 12.3158 19.1143 12.8185C19.6728 13.3132 20.0838 13.9037 20.3471 14.5899C20.6184 15.2762 20.7541 16.0222 20.7541 16.8282C20.7541 17.682 20.6144 18.464 20.3351 19.1741C20.0559 19.8843 19.6329 20.4947 19.0664 21.0054C18.4999 21.5161 17.7857 21.9151 16.9239 22.2024C16.0621 22.4816 15.0527 22.6213 13.8957 22.6213H11.6215V28.5939H8.03076V11.2266H13.8957Z"
        fill="white"
      />
      <path
        d="M30.9995 19.0066C30.9038 19.1342 30.808 19.234 30.7123 19.3058C30.6165 19.3696 30.4809 19.4016 30.3053 19.4016C30.1457 19.4016 29.9901 19.3577 29.8385 19.2699C29.6949 19.1741 29.5273 19.0744 29.3358 18.9707C29.1443 18.8589 28.9169 18.7592 28.6536 18.6714C28.3902 18.5757 28.0631 18.5278 27.6721 18.5278C27.1774 18.5278 26.7465 18.6196 26.3794 18.8031C26.0203 18.9786 25.7211 19.234 25.4817 19.5691C25.2423 19.9043 25.0628 20.3112 24.9431 20.79C24.8314 21.2688 24.7755 21.8074 24.7755 22.4058C24.7755 23.6666 25.0269 24.6321 25.5296 25.3024C26.0403 25.9727 26.7345 26.3078 27.6122 26.3078C27.9155 26.3078 28.1748 26.2839 28.3903 26.236C28.6137 26.1801 28.8052 26.1123 28.9648 26.0325C29.1323 25.9527 29.276 25.8649 29.3957 25.7692C29.5154 25.6734 29.6271 25.5857 29.7308 25.5059C29.8425 25.4261 29.9502 25.3622 30.054 25.3144C30.1657 25.2585 30.2894 25.2306 30.425 25.2306C30.6804 25.2306 30.8799 25.3263 31.0235 25.5178L31.9691 26.7148C31.618 27.1217 31.2429 27.4608 30.8439 27.7321C30.445 27.9955 30.03 28.2069 29.5991 28.3665C29.1762 28.5181 28.7453 28.6219 28.3065 28.6777C27.8676 28.7415 27.4327 28.7735 27.0018 28.7735C26.2438 28.7735 25.5256 28.6338 24.8474 28.3545C24.1691 28.0673 23.5746 27.6523 23.0639 27.1097C22.5533 26.5671 22.1463 25.9008 21.8431 25.1109C21.5478 24.3209 21.4002 23.4192 21.4002 22.4058C21.4002 21.5041 21.5319 20.6663 21.7952 19.8923C22.0585 19.1183 22.4455 18.448 22.9562 17.8815C23.4669 17.3149 24.0973 16.8721 24.8474 16.5529C25.6054 16.2257 26.4792 16.0621 27.4686 16.0621C28.4102 16.0621 29.2361 16.2137 29.9463 16.517C30.6564 16.8202 31.2948 17.2591 31.8613 17.8336L30.9995 19.0066Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13415_89506">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const DeliveryCrossDockIcon = ({ width = "19", height = "19" }) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_13415_89507)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#2CCE95"
      />
      <path
        d="M21.8029 19.9043C21.8029 21.173 21.5875 22.342 21.1566 23.4112C20.7337 24.4725 20.1312 25.3862 19.3492 26.1522C18.5752 26.9182 17.6416 27.5167 16.5484 27.9476C15.4552 28.3785 14.2424 28.5939 12.9098 28.5939H6.23096V11.2266H12.9098C14.2424 11.2266 15.4552 11.442 16.5484 11.8729C17.6416 12.3038 18.5752 12.9062 19.3492 13.6803C20.1312 14.4463 20.7337 15.3599 21.1566 16.4212C21.5875 17.4825 21.8029 18.6435 21.8029 19.9043ZM18.1164 19.9043C18.1164 18.9946 17.9967 18.1767 17.7573 17.4506C17.5179 16.7244 17.1748 16.11 16.728 15.6073C16.2811 15.1046 15.7345 14.7176 15.0882 14.4463C14.4498 14.175 13.7237 14.0393 12.9098 14.0393H9.84567V25.7812H12.9098C13.7237 25.7812 14.4498 25.6495 15.0882 25.3862C15.7345 25.1149 16.2811 24.7279 16.728 24.2252C17.1748 23.7145 17.5179 23.0961 17.7573 22.3699C17.9967 21.6438 18.1164 20.8219 18.1164 19.9043Z"
        fill="white"
      />
      <path
        d="M32.7999 19.0066C32.7041 19.1342 32.6084 19.234 32.5126 19.3058C32.4168 19.3696 32.2812 19.4016 32.1056 19.4016C31.9461 19.4016 31.7905 19.3577 31.6388 19.2699C31.4952 19.1741 31.3276 19.0744 31.1361 18.9707C30.9446 18.8589 30.7172 18.7592 30.4539 18.6714C30.1906 18.5757 29.8634 18.5278 29.4724 18.5278C28.9777 18.5278 28.5468 18.6196 28.1797 18.8031C27.8207 18.9786 27.5214 19.234 27.282 19.5691C27.0427 19.9043 26.8631 20.3112 26.7434 20.79C26.6317 21.2688 26.5759 21.8074 26.5759 22.4058C26.5759 23.6666 26.8272 24.6321 27.3299 25.3024C27.8406 25.9727 28.5348 26.3078 29.4126 26.3078C29.7158 26.3078 29.9751 26.2839 30.1906 26.236C30.414 26.1801 30.6055 26.1123 30.7651 26.0325C30.9327 25.9527 31.0763 25.8649 31.196 25.7692C31.3157 25.6734 31.4274 25.5857 31.5311 25.5059C31.6428 25.4261 31.7506 25.3622 31.8543 25.3144C31.966 25.2585 32.0897 25.2306 32.2253 25.2306C32.4807 25.2306 32.6802 25.3263 32.8238 25.5178L33.7694 26.7148C33.4183 27.1217 33.0432 27.4608 32.6443 27.7321C32.2453 27.9955 31.8304 28.2069 31.3995 28.3665C30.9765 28.5181 30.5457 28.6219 30.1068 28.6777C29.6679 28.7415 29.233 28.7735 28.8021 28.7735C28.0441 28.7735 27.3259 28.6338 26.6477 28.3545C25.9694 28.0673 25.3749 27.6523 24.8643 27.1097C24.3536 26.5671 23.9466 25.9008 23.6434 25.1109C23.3482 24.3209 23.2005 23.4192 23.2005 22.4058C23.2005 21.5041 23.3322 20.6663 23.5955 19.8923C23.8588 19.1183 24.2458 18.448 24.7565 17.8815C25.2672 17.3149 25.8976 16.8721 26.6477 16.5529C27.4057 16.2257 28.2795 16.0621 29.2689 16.0621C30.2105 16.0621 31.0364 16.2137 31.7466 16.517C32.4567 16.8202 33.0951 17.2591 33.6616 17.8336L32.7999 19.0066Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13415_89507">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const MultiStopIcon = ({ width = "19", height = "19", color = "#B38205" }) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_13415_89508)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill={color}
      />
      <path
        d="M29.5756 11.3164V28.6838H26.4037V18.0192C26.4037 17.7958 26.4077 17.5564 26.4157 17.301C26.4317 17.0457 26.4556 16.7863 26.4875 16.523L21.5203 25.9428C21.249 26.4615 20.8301 26.7208 20.2635 26.7208H19.7608C19.4815 26.7208 19.2342 26.657 19.0187 26.5293C18.8033 26.3937 18.6317 26.1982 18.504 25.9428L13.5129 16.4871C13.5368 16.7664 13.5568 17.0377 13.5727 17.301C13.5887 17.5564 13.5967 17.7958 13.5967 18.0192V28.6838H10.4248V11.3164H13.1538C13.3054 11.3164 13.4411 11.3204 13.5607 11.3284C13.6804 11.3364 13.7842 11.3603 13.8719 11.4002C13.9677 11.4321 14.0515 11.488 14.1233 11.5678C14.2031 11.6396 14.2789 11.7433 14.3507 11.879L19.2102 21.1432C19.3618 21.4224 19.5015 21.7097 19.6291 22.0049C19.7648 22.3002 19.8925 22.6034 20.0122 22.9146C20.1319 22.5954 20.2555 22.2842 20.3832 21.981C20.5189 21.6778 20.6625 21.3865 20.8141 21.1072L25.6377 11.879C25.7095 11.7433 25.7853 11.6396 25.8651 11.5678C25.9449 11.488 26.0287 11.4321 26.1165 11.4002C26.2122 11.3603 26.316 11.3364 26.4277 11.3284C26.5474 11.3204 26.687 11.3164 26.8466 11.3164H29.5756Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13415_89508">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const LinehaulIcon = ({ width = "19", height = "19" }) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_13415_89509)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#FFBA07"
      />
      <path
        d="M25.1532 25.7633V28.6838H14.8477V11.3164H18.4384V25.7633H25.1532Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13415_89509">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const MultiDayPickupIcon = ({ width = "19", height = "19" }) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_15598_103185)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#D23B71"
      />
      <path
        d="M31.5544 19.9659C32.6785 19.9659 33.4996 19.6949 34.0178 19.1528C34.544 18.6107 34.8071 17.8693 34.8071 16.9285C34.8071 16.498 34.7393 16.1074 34.6038 15.7566C34.4762 15.3979 34.2769 15.0949 34.0059 14.8478C33.7428 14.5927 33.4079 14.3974 33.0014 14.2618C32.5948 14.1263 32.1125 14.0585 31.5544 14.0585H29.2823V19.9659H31.5544ZM31.5544 11.332C32.7423 11.332 33.7667 11.4715 34.6277 11.7506C35.4967 12.0296 36.2102 12.4202 36.7682 12.9225C37.3263 13.4168 37.7369 14.0067 38 14.6923C38.271 15.3779 38.4065 16.1233 38.4065 16.9285C38.4065 17.7816 38.267 18.5628 37.988 19.2724C37.709 19.9819 37.2864 20.5918 36.7204 21.102C36.1544 21.6122 35.4409 22.0108 34.5799 22.2978C33.7189 22.5769 32.7104 22.7164 31.5544 22.7164H29.2823V28.6836H25.6948V11.332H31.5544Z"
        fill="white"
      />
      <path
        d="M22.0791 11.332V28.6836H18.9102V18.0287C18.9102 17.8055 18.9142 17.5663 18.9221 17.3112C18.9381 17.0561 18.962 16.797 18.9939 16.5339L14.0312 25.9451C13.7601 26.4633 13.3416 26.7224 12.7756 26.7224H12.2733C11.9943 26.7224 11.7471 26.6586 11.5319 26.5311C11.3166 26.3955 11.1452 26.2002 11.0177 25.9451L6.03105 16.498C6.05497 16.7771 6.0749 17.0481 6.09084 17.3112C6.10679 17.5663 6.11476 17.8055 6.11476 18.0287V28.6836H2.9458V11.332H5.6723C5.82377 11.332 5.9593 11.336 6.07888 11.344C6.19847 11.352 6.30211 11.3759 6.3898 11.4157C6.48547 11.4476 6.56918 11.5034 6.64093 11.5832C6.72065 11.6549 6.79638 11.7585 6.86813 11.8941L11.7232 21.1498C11.8747 21.4289 12.0142 21.7159 12.1418 22.0108C12.2773 22.3058 12.4048 22.6087 12.5244 22.9197C12.644 22.6008 12.7676 22.2899 12.8951 21.9869C13.0307 21.684 13.1742 21.393 13.3256 21.1139L18.1448 11.8941C18.2166 11.7585 18.2923 11.6549 18.3721 11.5832C18.4518 11.5034 18.5355 11.4476 18.6232 11.4157C18.7188 11.3759 18.8225 11.352 18.9341 11.344C19.0537 11.336 19.1932 11.332 19.3526 11.332H22.0791Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_15598_103185">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const MultiDayDeliveryIcon = ({ width = "19", height = "19" }) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_15598_103197)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#13B57B"
      />
      <path
        d="M39.6525 20.0018C39.6525 21.2694 39.4373 22.4373 39.0068 23.5056C38.5842 24.5659 37.9823 25.4787 37.2011 26.2441C36.4278 27.0094 35.495 27.6073 34.4028 28.0378C33.3106 28.4683 32.0988 28.6836 30.7675 28.6836H24.0947V11.332H30.7675C32.0988 11.332 33.3106 11.5473 34.4028 11.9778C35.495 12.4083 36.4278 13.0102 37.2011 13.7835C37.9823 14.5488 38.5842 15.4616 39.0068 16.5219C39.4373 17.5823 39.6525 18.7422 39.6525 20.0018ZM35.9694 20.0018C35.9694 19.093 35.8498 18.2758 35.6106 17.5504C35.3714 16.8249 35.0286 16.211 34.5822 15.7088C34.1357 15.2065 33.5896 14.8199 32.9439 14.5488C32.3061 14.2778 31.5806 14.1422 30.7675 14.1422H27.7061V25.8734H30.7675C31.5806 25.8734 32.3061 25.7418 32.9439 25.4787C33.5896 25.2077 34.1357 24.821 34.5822 24.3188C35.0286 23.8086 35.3714 23.1907 35.6106 22.4652C35.8498 21.7398 35.9694 20.9186 35.9694 20.0018Z"
        fill="white"
      />
      <path
        d="M20.479 11.332V28.6836H17.3101V18.0287C17.3101 17.8055 17.3141 17.5663 17.322 17.3112C17.338 17.0561 17.3619 16.797 17.3938 16.5339L12.4311 25.9451C12.16 26.4633 11.7415 26.7224 11.1755 26.7224H10.6732C10.3942 26.7224 10.147 26.6586 9.93179 26.5311C9.71654 26.3955 9.54513 26.2002 9.41758 25.9451L4.43095 16.498C4.45487 16.7771 4.4748 17.0481 4.49074 17.3112C4.50669 17.5663 4.51466 17.8055 4.51466 18.0287V28.6836H1.3457V11.332H4.0722C4.22368 11.332 4.3592 11.336 4.47879 11.344C4.59837 11.352 4.70201 11.3759 4.7897 11.4157C4.88537 11.4476 4.96908 11.5034 5.04083 11.5832C5.12055 11.6549 5.19629 11.7585 5.26804 11.8941L10.1231 21.1498C10.2746 21.4289 10.4141 21.7159 10.5417 22.0108C10.6772 22.3058 10.8047 22.6087 10.9243 22.9197C11.0439 22.6008 11.1675 22.2899 11.295 21.9869C11.4306 21.684 11.5741 21.393 11.7255 21.1139L16.5447 11.8941C16.6165 11.7585 16.6922 11.6549 16.772 11.5832C16.8517 11.5034 16.9354 11.4476 17.0231 11.4157C17.1187 11.3759 17.2224 11.352 17.334 11.344C17.4536 11.336 17.5931 11.332 17.7525 11.332H20.479Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_15598_103197">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const SameDayIcon = ({ width = "19", height = "19" }) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_15598_103209)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#5064AE"
      />
      <path
        d="M34.8644 20.0018C34.8644 21.2694 34.6492 22.4373 34.2187 23.5056C33.7962 24.5659 33.1943 25.4787 32.413 26.2441C31.6397 27.0094 30.7069 27.6073 29.6147 28.0378C28.5225 28.4683 27.3108 28.6836 25.9794 28.6836H19.3066V11.332H25.9794C27.3108 11.332 28.5225 11.5473 29.6147 11.9778C30.7069 12.4083 31.6397 13.0102 32.413 13.7835C33.1943 14.5488 33.7962 15.4616 34.2187 16.5219C34.6492 17.5823 34.8644 18.7422 34.8644 20.0018ZM31.1813 20.0018C31.1813 19.093 31.0617 18.2758 30.8225 17.5504C30.5833 16.8249 30.2405 16.211 29.7941 15.7088C29.3477 15.2065 28.8016 14.8199 28.1558 14.5488C27.518 14.2778 26.7926 14.1422 25.9794 14.1422H22.9181V25.8734H25.9794C26.7926 25.8734 27.518 25.7418 28.1558 25.4787C28.8016 25.2077 29.3477 24.821 29.7941 24.3188C30.2405 23.8086 30.5833 23.1907 30.8225 22.4652C31.0617 21.7398 31.1813 20.9186 31.1813 20.0018Z"
        fill="white"
      />
      <path
        d="M15.533 14.6564C15.4214 14.8397 15.3058 14.9753 15.1862 15.063C15.0746 15.1427 14.9271 15.1825 14.7438 15.1825C14.5684 15.1825 14.377 15.1228 14.1698 15.0032C13.9705 14.8756 13.7353 14.7401 13.4642 14.5966C13.1932 14.4531 12.8822 14.3215 12.5315 14.202C12.1807 14.0744 11.7701 14.0106 11.2998 14.0106C10.4706 14.0106 9.84881 14.198 9.43426 14.5727C9.0197 14.9394 8.81243 15.4217 8.81243 16.0196C8.81243 16.4023 8.92404 16.7212 9.14726 16.9763C9.37845 17.2234 9.67741 17.4387 10.0441 17.622C10.4188 17.8054 10.8414 17.9688 11.3117 18.1123C11.7821 18.2558 12.2644 18.4153 12.7587 18.5907C13.253 18.7581 13.7353 18.9574 14.2056 19.1886C14.676 19.4198 15.0945 19.7108 15.4613 20.0615C15.836 20.4123 16.1349 20.8428 16.3581 21.353C16.5893 21.8553 16.7049 22.4692 16.7049 23.1946C16.7049 23.9839 16.5654 24.7253 16.2864 25.4189C16.0153 26.1045 15.6207 26.7064 15.1025 27.2246C14.5843 27.7348 13.9426 28.1374 13.1772 28.4324C12.4199 28.7274 11.5589 28.8748 10.5942 28.8748C10.0441 28.8748 9.49405 28.819 8.94397 28.7074C8.40186 28.5958 7.87569 28.4403 7.36547 28.241C6.86322 28.0417 6.38887 27.8026 5.94242 27.5235C5.49598 27.2445 5.10534 26.9336 4.77051 26.5908L5.82284 24.8927C5.91054 24.7652 6.02613 24.6615 6.16963 24.5818C6.31313 24.4941 6.46461 24.4503 6.62405 24.4503C6.8393 24.4503 7.06651 24.53 7.30567 24.6894C7.54484 24.8489 7.81988 25.0243 8.1308 25.2156C8.44172 25.4069 8.80047 25.5823 9.20705 25.7418C9.62161 25.9012 10.1159 25.9809 10.6899 25.9809C11.527 25.9809 12.1727 25.7896 12.6271 25.4069C13.0895 25.0243 13.3207 24.4542 13.3207 23.6969C13.3207 23.2584 13.2051 22.9036 12.9739 22.6326C12.7507 22.3615 12.4557 22.1343 12.089 21.951C11.7223 21.7676 11.3037 21.6121 10.8334 21.4846C10.363 21.3491 9.8807 21.2016 9.38643 21.0421C8.89215 20.8827 8.40983 20.6913 7.93947 20.4681C7.46911 20.2449 7.05056 19.9499 6.68384 19.5832C6.31712 19.2165 6.01816 18.7621 5.78697 18.22C5.56374 17.6778 5.45213 17.0042 5.45213 16.199C5.45213 15.5533 5.57969 14.9274 5.8348 14.3215C6.08991 13.7157 6.46461 13.1775 6.95888 12.7072C7.45316 12.2368 8.05905 11.8581 8.77655 11.5711C9.50202 11.2841 10.3311 11.1406 11.2639 11.1406C12.3082 11.1406 13.2729 11.3041 14.1578 11.6309C15.0507 11.9498 15.8041 12.3963 16.4179 12.9703L15.533 14.6564Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_15598_103209">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const tootlTipDelay = AppConfig.tooltipDelay;

const LHDIcon = ({ width = "19", height = "19" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_6125_73944)">
  <path d="M3.66668 0C1.65361 0 0 1.65361 0 3.66668V20.3334C0 22.3465 1.65361 24.0001 3.66668 24.0001H20.3334C22.3465 24.0001 24.0001 22.3465 24.0001 20.3334V3.66668C24.0001 1.65361 22.3465 0 20.3334 0H3.66668Z" fill="#15C989"/>
  <path d="M14.6541 6.76489C15.7541 6.76489 16.7191 6.97989 17.5491 7.40989C18.3891 7.83989 19.0341 8.45489 19.4841 9.25489C19.9441 10.0449 20.1741 10.9649 20.1741 12.0149C20.1741 13.0649 19.9441 13.9849 19.4841 14.7749C19.0341 15.5549 18.3891 16.1599 17.5491 16.5899C16.7191 17.0199 15.7541 17.2349 14.6541 17.2349H10.9941V6.76489H14.6541ZM14.5791 15.4499C15.6791 15.4499 16.5291 15.1499 17.1291 14.5499C17.7291 13.9499 18.0291 13.1049 18.0291 12.0149C18.0291 10.9249 17.7291 10.0749 17.1291 9.46489C16.5291 8.84489 15.6791 8.53489 14.5791 8.53489H13.0941V15.4499H14.5791Z" fill="white"/>
  <path d="M5.92617 15.5699H9.37617V17.2349H3.82617V6.76489H5.92617V15.5699Z" fill="white"/>
  </g>
  <defs>
  <clipPath id="clip0_6125_73944">
  <rect width="24" height="24" fill="white"/>
  </clipPath>
  </defs>
  </svg>
);

const PLHIcon = ({ width = "19", height = "19" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_6125_73942)">
  <path d="M3.66668 0C1.65361 0 0 1.65361 0 3.66668V20.3334C0 22.3465 1.65361 24.0001 3.66668 24.0001H20.3334C22.3465 24.0001 24.0001 22.3465 24.0001 20.3334V3.66668C24.0001 1.65361 22.3465 0 20.3334 0H3.66668Z" fill="#FF2D78"/>
  <path d="M15.7641 15.5699H19.2141V17.2349H13.6641V6.76489H15.7641V15.5699Z" fill="white"/>
  <path d="M12.4221 10.0049C12.4221 10.5649 12.2871 11.0899 12.0171 11.5799C11.7571 12.0699 11.3421 12.4649 10.7721 12.7649C10.2121 13.0649 9.50211 13.2149 8.64211 13.2149H6.88711V17.2349H4.78711V6.76489H8.64211C9.45211 6.76489 10.1421 6.90489 10.7121 7.18489C11.2821 7.46489 11.7071 7.84989 11.9871 8.33989C12.2771 8.82989 12.4221 9.38489 12.4221 10.0049ZM8.55211 11.5199C9.13211 11.5199 9.56211 11.3899 9.84211 11.1299C10.1221 10.8599 10.2621 10.4849 10.2621 10.0049C10.2621 8.98489 9.69211 8.47489 8.55211 8.47489H6.88711V11.5199H8.55211Z" fill="white"/>
  </g>
  <defs>
  <clipPath id="clip0_6125_73942">
  <rect width="24" height="24" fill="white"/>
  </clipPath>
  </defs>
  </svg>
);

const PLHDIcon = ({ width = "19", height = "19" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6125_73946)">
      <path d="M3.66668 0C1.65361 0 0 1.65361 0 3.66668V20.3334C0 22.3465 1.65361 24.0001 3.66668 24.0001H20.3334C22.3465 24.0001 24.0001 22.3465 24.0001 20.3334V3.66668C24.0001 1.65361 22.3465 0 20.3334 0H3.66668Z" fill="#586FCC"/>
      <path d="M10.9541 15.3891L14.0073 15.4005V16.9498L9 16.9384V7.1958H10.9541V15.3891Z" fill="white"/>
      <path d="M22.9992 12.0407C22.9992 12.749 22.8789 13.4017 22.6383 13.9987C22.4022 14.5912 22.0658 15.1013 21.6292 15.529C21.1971 15.9567 20.6759 16.2908 20.0655 16.5314C19.4552 16.772 18.778 16.8923 18.034 16.8923L15.0508 16.8923V7.1958H18.034C18.778 7.1958 19.4552 7.31609 20.0655 7.55666C20.6759 7.79724 21.1971 8.13359 21.6292 8.56573C22.0658 8.99342 22.4022 9.50353 22.6383 10.096C22.8789 10.6886 22.9992 11.3368 22.9992 12.0407ZM20.9409 12.0407C20.9409 11.5328 20.8741 11.0762 20.7405 10.6708C20.6068 10.2653 20.4152 9.9223 20.1658 9.64163C19.9163 9.36096 19.6111 9.14489 19.2502 8.99342C18.8938 8.84195 18.4884 8.76621 18.034 8.76621L17.0689 8.76621V15.3218L18.034 15.3218C18.4884 15.3218 18.8938 15.2483 19.2502 15.1013C19.6111 14.9498 19.9163 14.7338 20.1658 14.4531C20.4152 14.168 20.6068 13.8227 20.7405 13.4173C20.8741 13.0119 20.9409 12.553 20.9409 12.0407Z" fill="white"/>
      <path d="M4.27447 12.0206C4.90264 12.0206 5.36151 11.8692 5.65109 11.5662C5.94512 11.2633 6.09214 10.849 6.09214 10.3233C6.09214 10.0827 6.05427 9.86439 5.97853 9.66836C5.90725 9.46789 5.79588 9.29859 5.6444 9.16049C5.49739 9.01792 5.31027 8.90877 5.08307 8.83304C4.85586 8.7573 4.58633 8.71943 4.27447 8.71943H3.00478V12.0206H4.27447ZM4.27447 7.1958C4.93828 7.1958 5.51075 7.27376 5.9919 7.42969C6.4775 7.58562 6.87623 7.80392 7.18808 8.08459C7.49994 8.3608 7.72937 8.69048 7.87639 9.07361C8.02786 9.45675 8.1036 9.8733 8.1036 10.3233C8.1036 10.8 8.02564 11.2365 7.86971 11.633C7.71378 12.0295 7.47766 12.3704 7.16135 12.6555C6.84504 12.9406 6.44632 13.1634 5.96517 13.3237C5.48402 13.4797 4.92046 13.5576 4.27447 13.5576H3.00478V16.8923H1V7.1958H4.27447Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_6125_73946">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const PLHHIcon = ({ width = "19", height = "19" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_6125_73946)">
    <path d="M3.66668 0C1.65361 0 0 1.65361 0 3.66668V20.3334C0 22.3465 1.65361 24.0001 3.66668 24.0001H20.3334C22.3465 24.0001 24.0001 22.3465 24.0001 20.3334V3.66668C24.0001 1.65361 22.3465 0 20.3334 0H3.66668Z" fill="#586FCC"/>
    <path d="M5 6.76489H7.1V15.5699H11V17.2349H5V6.76489Z" fill="white"/>
    <path d="M12 6.76489H14.1V11.1H16.9V6.76489H19V17.2349H16.9V12.9H14.1V17.2349H12V6.76489Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_6125_73946">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
);

const D2DIcon = ({ width = "19", height = "19" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z" fill="#586FCC"/>
    <path d="M8.80719 12.355C8.80719 12.8817 8.71552 13.3683 8.53219 13.815C8.35219 14.2583 8.09719 14.6433 7.76719 14.97C7.43719 15.2933 7.03885 15.5467 6.57219 15.73C6.10885 15.91 5.59385 16 5.02719 16H2.19719V8.715H5.02719C5.59385 8.715 6.10885 8.80667 6.57219 8.99C7.03885 9.17333 7.43719 9.42667 7.76719 9.75C8.09719 10.0733 8.35219 10.4583 8.53219 10.905C8.71552 11.3483 8.80719 11.8317 8.80719 12.355ZM7.07719 12.355C7.07719 11.995 7.03052 11.67 6.93719 11.38C6.84385 11.09 6.70885 10.845 6.53219 10.645C6.35885 10.4417 6.14552 10.2867 5.89219 10.18C5.63885 10.07 5.35052 10.015 5.02719 10.015H3.89719V14.7H5.02719C5.35052 14.7 5.63885 14.6467 5.89219 14.54C6.14552 14.43 6.35885 14.275 6.53219 14.075C6.70885 13.8717 6.84385 13.625 6.93719 13.335C7.03052 13.045 7.07719 12.7183 7.07719 12.355ZM13.9796 14.6C14.1463 14.6 14.2779 14.6467 14.3746 14.74C14.4713 14.83 14.5196 14.95 14.5196 15.1V16H9.39961V15.5C9.39961 15.4033 9.41961 15.3 9.45961 15.19C9.49961 15.08 9.56961 14.98 9.66961 14.89L11.7696 12.775C11.9496 12.595 12.1063 12.4233 12.2396 12.26C12.3729 12.0967 12.4829 11.9367 12.5696 11.78C12.6563 11.62 12.7213 11.4617 12.7646 11.305C12.8079 11.145 12.8296 10.9767 12.8296 10.8C12.8296 10.51 12.7596 10.2883 12.6196 10.135C12.4829 9.97833 12.2729 9.9 11.9896 9.9C11.7596 9.9 11.5646 9.96167 11.4046 10.085C11.2479 10.205 11.1396 10.355 11.0796 10.535C11.0096 10.7183 10.9179 10.84 10.8046 10.9C10.6913 10.96 10.5296 10.9733 10.3196 10.94L9.49961 10.795C9.55294 10.4317 9.65461 10.115 9.80461 9.845C9.95794 9.575 10.1463 9.35 10.3696 9.17C10.5963 8.99 10.8546 8.85667 11.1446 8.77C11.4346 8.68 11.7463 8.635 12.0796 8.635C12.4396 8.635 12.7629 8.68833 13.0496 8.795C13.3396 8.89833 13.5863 9.04333 13.7896 9.23C13.9929 9.41667 14.1479 9.64 14.2546 9.9C14.3646 10.1567 14.4196 10.44 14.4196 10.75C14.4196 11.0167 14.3813 11.2633 14.3046 11.49C14.2313 11.7167 14.1296 11.9333 13.9996 12.14C13.8696 12.3433 13.7179 12.5417 13.5446 12.735C13.3746 12.925 13.1929 13.1183 12.9996 13.315L11.5746 14.775C11.7579 14.7183 11.9396 14.675 12.1196 14.645C12.2996 14.615 12.4663 14.6 12.6196 14.6H13.9796ZM22.2154 12.355C22.2154 12.8817 22.1237 13.3683 21.9404 13.815C21.7604 14.2583 21.5054 14.6433 21.1754 14.97C20.8454 15.2933 20.4471 15.5467 19.9804 15.73C19.5171 15.91 19.0021 16 18.4354 16H15.6054V8.715H18.4354C19.0021 8.715 19.5171 8.80667 19.9804 8.99C20.4471 9.17333 20.8454 9.42667 21.1754 9.75C21.5054 10.0733 21.7604 10.4583 21.9404 10.905C22.1237 11.3483 22.2154 11.8317 22.2154 12.355ZM20.4854 12.355C20.4854 11.995 20.4387 11.67 20.3454 11.38C20.2521 11.09 20.1171 10.845 19.9404 10.645C19.7671 10.4417 19.5537 10.2867 19.3004 10.18C19.0471 10.07 18.7587 10.015 18.4354 10.015H17.3054V14.7H18.4354C18.7587 14.7 19.0471 14.6467 19.3004 14.54C19.5537 14.43 19.7671 14.275 19.9404 14.075C20.1171 13.8717 20.2521 13.625 20.3454 13.335C20.4387 13.045 20.4854 12.7183 20.4854 12.355Z" fill="white"/>
  </svg>
);

const D2TIcon = ({ width = "19", height = "19" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z" fill="#FF2D78"/>
    <path d="M9.56402 12.355C9.56402 12.8817 9.47236 13.3683 9.28902 13.815C9.10902 14.2583 8.85402 14.6433 8.52402 14.97C8.19402 15.2933 7.79569 15.5467 7.32902 15.73C6.86569 15.91 6.35069 16 5.78402 16H2.95402V8.715H5.78402C6.35069 8.715 6.86569 8.80667 7.32902 8.99C7.79569 9.17333 8.19402 9.42667 8.52402 9.75C8.85402 10.0733 9.10902 10.4583 9.28902 10.905C9.47236 11.3483 9.56402 11.8317 9.56402 12.355ZM7.83402 12.355C7.83402 11.995 7.78736 11.67 7.69402 11.38C7.60069 11.09 7.46569 10.845 7.28902 10.645C7.11569 10.4417 6.90236 10.2867 6.64902 10.18C6.39569 10.07 6.10736 10.015 5.78402 10.015H4.65402V14.7H5.78402C6.10736 14.7 6.39569 14.6467 6.64902 14.54C6.90236 14.43 7.11569 14.275 7.28902 14.075C7.46569 13.8717 7.60069 13.625 7.69402 13.335C7.78736 13.045 7.83402 12.7183 7.83402 12.355ZM14.7364 14.6C14.9031 14.6 15.0348 14.6467 15.1314 14.74C15.2281 14.83 15.2764 14.95 15.2764 15.1V16H10.1564V15.5C10.1564 15.4033 10.1764 15.3 10.2164 15.19C10.2564 15.08 10.3264 14.98 10.4264 14.89L12.5264 12.775C12.7064 12.595 12.8631 12.4233 12.9964 12.26C13.1298 12.0967 13.2398 11.9367 13.3264 11.78C13.4131 11.62 13.4781 11.4617 13.5214 11.305C13.5648 11.145 13.5864 10.9767 13.5864 10.8C13.5864 10.51 13.5164 10.2883 13.3764 10.135C13.2398 9.97833 13.0298 9.9 12.7464 9.9C12.5164 9.9 12.3214 9.96167 12.1614 10.085C12.0048 10.205 11.8964 10.355 11.8364 10.535C11.7664 10.7183 11.6748 10.84 11.5614 10.9C11.4481 10.96 11.2864 10.9733 11.0764 10.94L10.2564 10.795C10.3098 10.4317 10.4114 10.115 10.5614 9.845C10.7148 9.575 10.9031 9.35 11.1264 9.17C11.3531 8.99 11.6114 8.85667 11.9014 8.77C12.1914 8.68 12.5031 8.635 12.8364 8.635C13.1964 8.635 13.5198 8.68833 13.8064 8.795C14.0964 8.89833 14.3431 9.04333 14.5464 9.23C14.7498 9.41667 14.9048 9.64 15.0114 9.9C15.1214 10.1567 15.1764 10.44 15.1764 10.75C15.1764 11.0167 15.1381 11.2633 15.0614 11.49C14.9881 11.7167 14.8864 11.9333 14.7564 12.14C14.6264 12.3433 14.4748 12.5417 14.3014 12.735C14.1314 12.925 13.9498 13.1183 13.7564 13.315L12.3314 14.775C12.5148 14.7183 12.6964 14.675 12.8764 14.645C13.0564 14.615 13.2231 14.6 13.3764 14.6H14.7364ZM21.5972 10.055H19.5472V16H17.8572V10.055H15.8072V8.715H21.5972V10.055Z" fill="white"/>
  </svg>
);

const T2DIcon = ({ width = "19", height = "19" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z" fill="#10B981"/>
    <path d="M8.18902 10.055H6.13902V16H4.44902V10.055H2.39902V8.715H8.18902V10.055ZM13.2228 14.6C13.3894 14.6 13.5211 14.6467 13.6178 14.74C13.7144 14.83 13.7628 14.95 13.7628 15.1V16H8.64277V15.5C8.64277 15.4033 8.66277 15.3 8.70277 15.19C8.74277 15.08 8.81277 14.98 8.91277 14.89L11.0128 12.775C11.1928 12.595 11.3494 12.4233 11.4828 12.26C11.6161 12.0967 11.7261 11.9367 11.8128 11.78C11.8994 11.62 11.9644 11.4617 12.0078 11.305C12.0511 11.145 12.0728 10.9767 12.0728 10.8C12.0728 10.51 12.0028 10.2883 11.8628 10.135C11.7261 9.97833 11.5161 9.9 11.2328 9.9C11.0028 9.9 10.8078 9.96167 10.6478 10.085C10.4911 10.205 10.3828 10.355 10.3228 10.535C10.2528 10.7183 10.1611 10.84 10.0478 10.9C9.93444 10.96 9.77277 10.9733 9.56277 10.94L8.74277 10.795C8.79611 10.4317 8.89777 10.115 9.04777 9.845C9.20111 9.575 9.38944 9.35 9.61277 9.17C9.83944 8.99 10.0978 8.85667 10.3878 8.77C10.6778 8.68 10.9894 8.635 11.3228 8.635C11.6828 8.635 12.0061 8.68833 12.2928 8.795C12.5828 8.89833 12.8294 9.04333 13.0328 9.23C13.2361 9.41667 13.3911 9.64 13.4978 9.9C13.6078 10.1567 13.6628 10.44 13.6628 10.75C13.6628 11.0167 13.6244 11.2633 13.5478 11.49C13.4744 11.7167 13.3728 11.9333 13.2428 12.14C13.1128 12.3433 12.9611 12.5417 12.7878 12.735C12.6178 12.925 12.4361 13.1183 12.2428 13.315L10.8178 14.775C11.0011 14.7183 11.1828 14.675 11.3628 14.645C11.5428 14.615 11.7094 14.6 11.8628 14.6H13.2228ZM21.4586 12.355C21.4586 12.8817 21.3669 13.3683 21.1836 13.815C21.0036 14.2583 20.7486 14.6433 20.4186 14.97C20.0886 15.2933 19.6902 15.5467 19.2236 15.73C18.7602 15.91 18.2452 16 17.6786 16H14.8486V8.715H17.6786C18.2452 8.715 18.7602 8.80667 19.2236 8.99C19.6902 9.17333 20.0886 9.42667 20.4186 9.75C20.7486 10.0733 21.0036 10.4583 21.1836 10.905C21.3669 11.3483 21.4586 11.8317 21.4586 12.355ZM19.7286 12.355C19.7286 11.995 19.6819 11.67 19.5886 11.38C19.4952 11.09 19.3602 10.845 19.1836 10.645C19.0102 10.4417 18.7969 10.2867 18.5436 10.18C18.2902 10.07 18.0019 10.015 17.6786 10.015H16.5486V14.7H17.6786C18.0019 14.7 18.2902 14.6467 18.5436 14.54C18.7969 14.43 19.0102 14.275 19.1836 14.075C19.3602 13.8717 19.4952 13.625 19.5886 13.335C19.6819 13.045 19.7286 12.7183 19.7286 12.355Z" fill="white"/>
  </svg>
);

const T2TIcon = ({ width = "19", height = "19" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z" fill="#FFBA07"/>
    <path d="M8.94586 10.055H6.89586V16H5.20586V10.055H3.15586V8.715H8.94586V10.055ZM13.9796 14.6C14.1463 14.6 14.2779 14.6467 14.3746 14.74C14.4713 14.83 14.5196 14.95 14.5196 15.1V16H9.39961V15.5C9.39961 15.4033 9.41961 15.3 9.45961 15.19C9.49961 15.08 9.56961 14.98 9.66961 14.89L11.7696 12.775C11.9496 12.595 12.1063 12.4233 12.2396 12.26C12.3729 12.0967 12.4829 11.9367 12.5696 11.78C12.6563 11.62 12.7213 11.4617 12.7646 11.305C12.8079 11.145 12.8296 10.9767 12.8296 10.8C12.8296 10.51 12.7596 10.2883 12.6196 10.135C12.4829 9.97833 12.2729 9.9 11.9896 9.9C11.7596 9.9 11.5646 9.96167 11.4046 10.085C11.2479 10.205 11.1396 10.355 11.0796 10.535C11.0096 10.7183 10.9179 10.84 10.8046 10.9C10.6913 10.96 10.5296 10.9733 10.3196 10.94L9.49961 10.795C9.55294 10.4317 9.65461 10.115 9.80461 9.845C9.95794 9.575 10.1463 9.35 10.3696 9.17C10.5963 8.99 10.8546 8.85667 11.1446 8.77C11.4346 8.68 11.7463 8.635 12.0796 8.635C12.4396 8.635 12.7629 8.68833 13.0496 8.795C13.3396 8.89833 13.5863 9.04333 13.7896 9.23C13.9929 9.41667 14.1479 9.64 14.2546 9.9C14.3646 10.1567 14.4196 10.44 14.4196 10.75C14.4196 11.0167 14.3813 11.2633 14.3046 11.49C14.2313 11.7167 14.1296 11.9333 13.9996 12.14C13.8696 12.3433 13.7179 12.5417 13.5446 12.735C13.3746 12.925 13.1929 13.1183 12.9996 13.315L11.5746 14.775C11.7579 14.7183 11.9396 14.675 12.1196 14.645C12.2996 14.615 12.4663 14.6 12.6196 14.6H13.9796ZM20.8404 10.055H18.7904V16H17.1004V10.055H15.0504V8.715H20.8404V10.055Z" fill="white"/>
  </svg>
);

const L2LIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <rect width="40" height="40" rx="6.111" fill="#617AD6" />

    <text
      x="20"
      y="26"
      textAnchor="middle"
      fill="white"
      fontSize="19"
      fontWeight="900"
      fontFamily="Arial, sans-serif"
    >
      L2L
    </text>
  </svg>
);

const OSIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6125_73944)">
      <path
        d="M3.66668 0C1.65361 0 0 1.65361 0 3.66668V20.3334C0 22.3465 1.65361 24.0001 3.66668 24.0001H20.3334C22.3465 24.0001 24.0001 22.3465 24.0001 20.3334V3.66668C24.0001 1.65361 22.3465 0 20.3334 0H3.66668Z"
        fill="#AABDCD"
      />

      <path
        d="M7.4 6.76C9.8 6.76 11.5 8.4 11.5 12C11.5 15.6 9.8 17.24 7.4 17.24C5 17.24 3.3 15.6 3.3 12C3.3 8.4 5 6.76 7.4 6.76ZM7.4 15.45C8.6 15.45 9.4 14.3 9.4 12C9.4 9.7 8.6 8.55 7.4 8.55C6.2 8.55 5.4 9.7 5.4 12C5.4 14.3 6.2 15.45 7.4 15.45Z"
        fill="white"
      />

      <path
        d="M14.2 14.8C14.2 15.3 14.6 15.6 15.5 15.6C16.5 15.6 17.1 15.1 17.1 14.4C17.1 13.6 16.5 13.2 15.1 12.8C13.2 12.3 12.1 11.6 12.1 9.9C12.1 8 13.5 6.7 15.6 6.7C17.8 6.7 19.1 7.8 19.2 9.7H17.1C17 8.9 16.5 8.5 15.6 8.5C14.7 8.5 14.2 8.9 14.2 9.6C14.2 10.3 14.8 10.7 16.2 11.1C18.1 11.6 19.3 12.3 19.3 14.1C19.3 16.2 17.8 17.3 15.5 17.3C13.1 17.3 12.1 16.1 12 14.8H14.2Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_6125_73944">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);


const renderOrderTypeIconNew = (order, type, orderTypeKey, isInAggrid, orgCode = "", isCLIEnabled = false) => {
  switch (type) {
    case "R":
      return (
        <Fragment>
          <Tooltip title={orgCode === 'TA' ? "Pickup Only" : 'Pickup'} mouseEnterDelay={tootlTipDelay} >
            <Icon component={() => orgCode === 'TA' ? <PickupOnlyIcon /> : <PickupIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "D":
      return (
        <Fragment>
          <Tooltip title={orgCode === 'TA' ? "Delivery Only" : 'Delivery'} mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => orgCode === 'TA' ? <DeliveryOnlyIcon /> : <DeliveryIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "OR":
      return (
        <Fragment>
          <Tooltip title="Pickup Only">
            <Icon component={() => <PickupIcon />} mouseEnterDelay={tootlTipDelay}/>
          </Tooltip>
        </Fragment>
      );
    case "OD":
      return (
        <Fragment>
          <Tooltip title="Delivery Only" mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <DeliveryIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "LH":
    case "NLH":
      return (
        <Fragment>
          <Tooltip title={orgCode == "MWE" ? "Terminal To Terminal" : "Linehaul"} mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => orgCode == "MWE" ? <T2TIcon /> : <LinehaulIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "RD":
      return (
        <Fragment>
          <Tooltip title={isCLIEnabled ? "Delivery Airline" : "Recovery & Delivery"} mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <RecoveryDeliveryIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "RT":
      return (
        <Fragment>
          <Tooltip title="Recovery & Transfer" mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <RecoveryTransferIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "AFW":
      return (
        <Fragment>
          <Tooltip title="Recovery & Transfer" mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <RecoveryTransferIcon />} />
          </Tooltip>
        </Fragment>
      );   
    case "OBT":
      return (
        <Fragment>
          <Tooltip title={isCLIEnabled ? "P/U" : "Outbound Transfer"} mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <OutboundTransferIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "CDK":
      return (
        <Fragment>
          <Tooltip title="Cross Dock" mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <CrossDockIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "WO":
      return (
        <Fragment>
          <Tooltip title={I18n.t('general.warehouse')} mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <WarehouseOrderIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "PCDK":
      return (
        <Fragment>
          <Tooltip title="Pickup & Cross Dock" mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <PickupCrossDockIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "CDKD":
      return (
        <Fragment>
          <Tooltip title="Cross Dock & Delivery & " mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <DeliveryCrossDockIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "MS":
      return (
        <Fragment>
          <Tooltip title="Multi Stop" mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <MultiStopIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "T":
      return (
        <Fragment>
          <Tooltip title={orgCode == "MWE" ? "Local To Local" : "Pickup & Delivery"} mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => orgCode == "MWE" ? <L2LIcon /> : <PickDeliveryIcon />} />
            {/* <Icon component={() => <PickDeliveryIcon />} /> */}
          </Tooltip>
        </Fragment>
      );
    case "B":
      return (
        <Fragment>
          <Tooltip title="Beyond" mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <BeyondIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "E":
      return (
        <Fragment>
          <Tooltip title="Exclusive" mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <ExclusiveIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "H":
      return (
        <Fragment>
          <Tooltip title="Hotshot" mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <HotshotIcon />} />
          </Tooltip>
        </Fragment>
      );

    case "SDR":
      return (
        <Fragment>
          <Tooltip title="Single Day Pickup" mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <SameDayIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "SDD":
      return (
        <Fragment>
          <Tooltip title="Single Day Delivery" mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <SameDayIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "MDR":
      return (
        <Fragment>
          <Tooltip title="Multi Day Pickup" mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <MultiDayPickupIcon />} />
          </Tooltip>
        </Fragment>
      );
    case "MDD":
      return (
        <Fragment>
          <Tooltip title="Multi Day Delivery" mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <MultiDayDeliveryIcon />} />
          </Tooltip>
        </Fragment>
      );
    case 'M':
      return (
        <Fragment>
          <Tooltip title="Move" mouseEnterDelay={tootlTipDelay}>
            <Icon component={() => <MultiStopIcon color={'blue'} />} />
          </Tooltip>
        </Fragment>
      );
    case 'PLH':
      return (
        <Fragment>
          <Tooltip title={orgCode == "MWE" ? "Door To Terminal" : "Pickup & Linehaul"}>
            <Icon component={() => orgCode == "MWE" ? <D2TIcon /> : <PLHIcon />} />
          </Tooltip>
        </Fragment>
      );
      case 'LHD':
        return (
          <Fragment>
            <Tooltip title={orgCode == "MWE" ? "Terminal To Door" : "Linehaul & Delivery"}>
              <Icon component={() => orgCode == "MWE" ? <T2DIcon /> : <LHDIcon/>} />
            </Tooltip>
          </Fragment>
        );
      case 'PLHD':
      return (
        <Fragment>
          <Tooltip title={orgCode == "SSF" ? "Line Haul" : orgCode == "MWE" ? "Door To Door" : "Pickup,Linehaul & Delivery"}>
            <Icon component={() => orgCode == "SSF" ? <PLHHIcon/> : orgCode == "MWE" ? <D2DIcon /> : <PLHDIcon/>} />
          </Tooltip>
        </Fragment>
      );
    case 'OS':
      return (
        <Fragment>
          <Tooltip title="On-Site Service">
            <Icon component={() => <OSIcon />} />
          </Tooltip>
        </Fragment>
      );
    case 'APAD':
      return (
        <Fragment>
          <Tooltip title="Airport to Airport">
            <Icon component={() => <AirportToAirportIcon />} />
          </Tooltip>
        </Fragment>
      );
    default:
      return (
        <Fragment>
          <Tooltip title={AppConfig?.orderTypeLabels[order[orderTypeKey]]}>
            <Tag
              color={AppConfig?.orderTypeColorMapping[order[orderTypeKey]]}
              style={
                !isInAggrid
                  ? {
                      padding: "0 2px",
                      fontWeight: "bold",
                      fontSize: 9,
                      height: 20,
                      width: 20,
                      textAlign: "center",
                      margin: 0,
                    }
                  : {}
              }
            >
              {getOrderTypeLabel(order, "type_of_order", "related_order")}
            </Tag>
          </Tooltip>
        </Fragment>
      );
  }
};

const PickupOnlyIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <g clipPath="url(#clip0_13415_89499)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#FF2D78"
      />
      <path
      d="M13.8957 19.8684C15.0208 19.8684 15.8427 19.597 16.3614 19.0544C16.888 18.5118 17.1513 17.7697 17.1513 16.8282C17.1513 16.3973 17.0835 16.0063 16.9478 15.6552C16.8202 15.2961 16.6207 14.9929 16.3494 14.7455C16.0861 14.4902 15.7509 14.2947 15.344 14.159C14.937 14.0234 14.4543 13.9555 13.8957 13.9555H11.6215V19.8684H13.8957ZM13.8957 11.2266C15.0846 11.2266 16.11 11.3662 16.9718 11.6455C17.8415 11.9248 18.5557 12.3158 19.1143 12.8185C19.6728 13.3132 20.0838 13.9037 20.3471 14.5899C20.6184 15.2762 20.7541 16.0222 20.7541 16.8282C20.7541 17.682 20.6144 18.464 20.3351 19.1741C20.0559 19.8843 19.6329 20.4947 19.0664 21.0054C18.4999 21.5161 17.7857 21.9151 16.9239 22.2024C16.0621 22.4816 15.0527 22.6213 13.8957 22.6213H11.6215V28.5939H8.03076V11.2266H13.8957Z"
      fill="white"
    />
      <path
  d="M29 14.8C27.2 14.8 25.7 15.5 24.6 16.7C23.5 17.9 23 19.3 23 21C23 22.7 23.5 24.1 24.6 25.3C25.7 26.5 27.2 27.1 29 27.1C30.8 27.1 32.3 26.5 33.4 25.3C34.5 24.1 35 22.7 35 21C35 19.3 34.5 17.9 33.4 16.7C32.3 15.5 30.8 14.8 29 14.8ZM29 17.6C29.8 17.6 30.5 18 31.1 18.7C31.6 19.4 31.9 20.2 31.9 21C31.9 21.8 31.6 22.6 31.1 23.3C30.5 24 29.8 24.4 29 24.4C28.2 24.4 27.5 24 26.9 23.3C26.4 22.6 26.1 21.8 26.1 21C26.1 20.2 26.4 19.4 26.9 18.7C27.5 18 28.2 17.6 29 17.6Z"
  fill="white"
/>
    </g>
    <defs>
      <clipPath id="clip0_13415_89499">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const DeliveryOnlyIcon = ({ width = "19", height = "19" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <g clipPath="url(#clip0_13415_89500)">
      <path
        d="M6.11113 0C2.75601 0 0 2.75601 0 6.11113V33.889C0 37.2441 2.75601 40.0001 6.11113 40.0001H33.889C37.2441 40.0001 40.0001 37.2441 40.0001 33.889V6.11113C40.0001 2.75601 37.2441 0 33.889 0H6.11113Z"
        fill="#15C989"
      />
      <path
        d="M21.8029 19.9043C21.8029 21.173 21.5875 22.342 21.1566 23.4112C20.7337 24.4725 20.1312 25.3862 19.3492 26.1522C18.5752 26.9182 17.6416 27.5167 16.5484 27.9476C15.4552 28.3785 14.2424 28.5939 12.9098 28.5939H6.23096V11.2266H12.9098C14.2424 11.2266 15.4552 11.442 16.5484 11.8729C17.6416 12.3038 18.5752 12.9062 19.3492 13.6803C20.1312 14.4463 20.7337 15.3599 21.1566 16.4212C21.5875 17.4825 21.8029 18.6435 21.8029 19.9043ZM18.1164 19.9043C18.1164 18.9946 17.9967 18.1767 17.7573 17.4506C17.5179 16.7244 17.1748 16.11 16.728 15.6073C16.2811 15.1046 15.7345 14.7176 15.0882 14.4463C14.4498 14.175 13.7237 14.0393 12.9098 14.0393H9.84567V25.7812H12.9098C13.7237 25.7812 14.4498 25.6495 15.0882 25.3862C15.7345 25.1149 16.2811 24.7279 16.728 24.2252C17.1748 23.7145 17.5179 23.0961 17.7573 22.3699C17.9967 21.6438 18.1164 20.8219 18.1164 19.9043Z"
        fill="white"
      />
       <path
      d="M29 15.5C27.5 15.5 26.2 16.1 25.3 17.1C24.4 18.1 23.9 19.4 23.9 21C23.9 22.6 24.4 23.9 25.3 24.9C26.2 25.9 27.5 26.4 29 26.4C30.5 26.4 31.8 25.9 32.7 24.9C33.6 23.9 34.1 22.6 34.1 21C34.1 19.4 33.6 18.1 32.7 17.1C31.8 16.1 30.5 15.5 29 15.5ZM29 17.8C29.7 17.8 30.3 18.1 30.8 18.7C31.3 19.3 31.6 20.1 31.6 21C31.6 21.9 31.3 22.7 30.8 23.3C30.3 23.9 29.7 24.2 29 24.2C28.3 24.2 27.7 23.9 27.2 23.3C26.7 22.7 26.4 21.9 26.4 21C26.4 20.1 26.7 19.3 27.2 18.7C27.7 18.1 28.3 17.8 29 17.8Z"
      fill="white"
    />
    </g>
    <defs>
      <clipPath id="clip0_13415_89500">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export {
  OSIcon,
  PickupIcon,
  DeliveryIcon,
  PickDeliveryIcon,
  RecoveryDeliveryIcon,
  RecoveryTransferIcon,
  OutboundTransferIcon,
  CrossDockIcon,
  PickupCrossDockIcon,
  DeliveryCrossDockIcon,
  MultiStopIcon,
  LinehaulIcon,
  renderOrderTypeIconNew,
  MultiDayPickupIcon,
  MultiDayDeliveryIcon,
  SameDayIcon,
  AirportToAirportIcon,
  BeyondIcon,
  ExclusiveIcon,
  HotshotIcon
};